
export enum DocumentType {
    Identity = 1,
    ProofOfAddress = 2,
    BankStatement = 3,
    TaxDocument = 5,
    DebitOrderAuthority = 8,
    InvestmentAdviceMandate = 9,
}